import {
  GiftCardLineItemModel,
  LineItemType,
  ProductLineItemModel,
  type ILineItem,
  type LineItemModel
} from './LineItem';

/**
 * Obtain the model from the {@link ILineItem line item}.
 * @param item - The provided {@link ILineItem line item}.
 * @returns - A {@link ProductLineItemModel} if the {@link ILineItem.type} is
 * a {@link LineItemType.Product product} otheriwse a {@link GiftCardLineItemModel}.
 */
export const getModelFromItem = (item: ILineItem): LineItemModel =>
  item.type === LineItemType.Product
    ? ProductLineItemModel.from(item)
    : GiftCardLineItemModel.from(item);
